import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import GuestMessagingSettings from './guest-setting';
import GuestMessagingReservations from './reservation';
import GuestMessagingInsight_logs from './insightsAndlogs';
import { getUserRole } from '../../../../helpers/AxiosAPI';

const GuestMessaging = ({ match }) => {
    const role = getUserRole();

    return (
        <div className="dashboard-wrapper">
            {role === 'Agent' ? (
                <Switch>
                    <Route
                        exact
                        path={`${match.url}/`}
                        component={GuestMessagingReservations}
                    />
                    <Route
                        path={`${match.url}/reservations`}
                        component={GuestMessagingReservations}
                    />

                    <Route
                        path={`${match.url}/insights-logs`}
                        component={GuestMessagingInsight_logs}
                    />

                    <Redirect to="/access-denied" />
                </Switch>
            ) : role === 'NA' ? (
                <Switch>
                    <Redirect to="/access-denied" />
                </Switch>
            ) : (
                <Switch>
                    <Route
                        path={`${match.url}/guest-setting`}
                        component={GuestMessagingSettings}
                    />
                    <Route
                        path={`${match.url}/reservations`}
                        component={GuestMessagingReservations}
                    />
                    <Route
                        path={`${match.url}/insights-logs`}
                        component={GuestMessagingInsight_logs}
                    />

                    <Redirect to="/access-denied" />
                </Switch>
            )
            }

        </div >
    );
};

export default GuestMessaging;
